/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { Industry } from '@app/settings/industries/industries.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Logger } from '@app/core';
import { Locale } from '@app/settings/locales/locales.model';
import { IndustriesService } from '@app/settings/industries/industries.service';

const log = new Logger('localesFormComponent');

@Component({
  selector: 'app-industries-form',
  templateUrl: './industries-form.component.html',
  styleUrls: ['./industries-form.component.scss'],
})
export class IndustriesFormComponent implements OnInit {
  @Input() industry: Industry = null;

  form: FormGroup;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private industryService: IndustriesService
  ) {}

  ngOnInit() {
    this.createForm();
  }

  save() {
    log.debug(this);
    if (this.industry && this.industry.id) {
      const industry: Industry = this.industry.deserialize(this.form.value);
      this.industryService.update(industry).subscribe((res) => this.modal.close('Save click'));
    } else {
      const industry: Industry = new Locale().deserialize(this.form.value);
      this.industryService.store(industry).subscribe((res) => this.modal.close(res));
    }
  }

  private createForm() {
    this.form = this.formBuilder.group({
      id: [null],
      name: ['', [Validators.required]],
      active: [true],
    });

    if (this.industry && this.industry.id) {
      this.industryService.show(this.industry.id).subscribe((industry: Industry) => {
        this.form.patchValue(industry);
      });
    } else if (this.industry) {
      this.form.patchValue(this.industry);
    }
  }
}
